import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { SnackbarNudgeComponent } from "../../components/nudges/snackbar-nudge/snackbar-nudge.component";
import { HolidayNudgeComponent } from "../../components/nudges/holiday-nudge/holiday-nudge.component";

export enum NudgeType {
    LTP = 'LTP',
    ASMGSM = 'ASMGSM',
    BROADCAST = 'BROADCAST',
    CONNECTIVITY = 'CONNECTIVITY'
}

export interface NudgeData {
    id: number;
    title?: string;
    body: string;
    icon: string;
}

export abstract class NudgeBase implements NudgeData { 
    id: number;
    title?: string;
    body: string;
    icon: string;

    constructor(data: NudgeData) {
        this.id = data.id;
        this.title = data.title;
        this.body = data.body;
        this.icon = data.icon;
    }

    abstract showNudge(matSnackBar: MatSnackBar,currentNudge:number);
}

export class PopupNudge extends NudgeBase {

    constructor(data: NudgeData) {
        super(data);
    }

    showNudge (matSnackBar : MatSnackBar , currentNudge: number): MatSnackBarRef<SnackbarNudgeComponent> {
        return matSnackBar.openFromComponent(SnackbarNudgeComponent, {
            data: {
                message : this.body,
                icon : this.icon,
                currentNudge,
            },
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['broadcast-nudge-snackbar']
        });
    }
}

export class HolidayNudge extends NudgeBase {

    constructor(data: NudgeData) {
        super(data);
    }

    showNudge (matSnackBar : MatSnackBar , currentNudge): MatSnackBarRef<HolidayNudgeComponent> {
        return matSnackBar.openFromComponent(HolidayNudgeComponent, {
            data: {
                message : this.body,
                icon : this.icon,
                title: this.title,
                currentNudge,
            },
            horizontalPosition: 'end',
            verticalPosition: 'bottom',
            panelClass: ['holiday-nudge-snackbar']
        });
    }
}